enum EcSite {
    amazon  = 'amazon',
    kojima  = 'kojima',
    yahoo   = 'yahoo',
    rakuten = 'rakuten',
}
export default EcSite;
